import ViewAsVisitorBarContainer from './ViewAsVisitorBar.container';
import ViewAsVisitorBar from './ViewAsVisitorBar';
export default ViewAsVisitorBarContainer(ViewAsVisitorBar);
